const FRAME_COUNT = 56;
const FRAME_URLS = []
const SPEED_NAMES = ['STEADY', 'FAST', 'EXTREME'];
const PLAY_HINTS = ['WATCH THE DROP.', "IT'S GETTING FASTER.", 'STAY SHARP.'];

// 【配置对象】
const gameOptions = {
    name: 'StopBeforeBurn',
    data() {
        return {
            currentScreen: 'start',
            faces: [ 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/4_1397c377-b5f6-419f-b2ff-0f286fb10133.avif'],
            selectedFace: 0,
            best: 0,
            showBest: false,
            frameIndex: 0,

            // round=0/1/2，level 是模拟液位百分比 running 只在倒计时结束后为 true；duration 单位为毫秒。
            round: 0,
            score: 0,
            level: 82,
            running: false,
            startTime: 0,
            duration: 5000,
            curve: { breakpoint: 0.5, weights: [0.75, 1.95, 0.60, 2.60] },
            // 每轮记录 {points,saved}，perfect 统计完美停止，saves 统计 ABT 出手次数。
            perfect: 0,
            saves: 0,
            instruction: 'Get ready…',
            countdownVisible: false,
            countdownText: '3',
            flashVisible: false,
            flashData: { points: 0, label: '', icon: '', detail: '', saved: false },
            game_ui:false,
            gameShow:true,
            codeShow:false,
            // popup------------------------------------------
            loadFlag:false,
            sendFlag:false,
            submitFlag:false,
            popup:false,
            winPopup:false,
            recordPopup:false,
            rulePopup:false,
            loginPopup:false,
            isSend:false,
            isLogin:false,
            sendText:'Send code',
            findText:'',
            user:{
                name:'',
                email:'',
                code:'',
                country:'Country',
                invite_code:'',
                points:0,
                is_win:false,
                invite_num:0
            },
            popup1:false,
            select_flag1:0,
            countryArr:[],
            pointsHistory:[],
            gameHistory:[],
            rankArr:[],
            userRank:{},
            recordNav:['Game Score','Share & Invite'], 
            recordIndex:0,
            weeklyText:['OCT 27-NOV 1','NOV 2-8','NOV 9-15','NOV 16-22','NOV 23-29'],
            weeklyIndex:0,
            selectIndex:0,
            download:false
        };
    },
    computed: {
        currentFrameUrl() {
            return FRAME_URLS[this.frameIndex];
        },
        speedName() {
            return SPEED_NAMES[this.round] || '';
        },
        displayGameHistory() {
            const list = this.gameHistory.slice().reverse();
    
            if (list.length === 0) return list;
    
            // 找出 score 最大的数据下标
            const maxIndex = list.reduce((maxIdx, item, index, arr) => {
                return Number(item.score) > Number(arr[maxIdx].score)
                    ? index
                    : maxIdx;
            }, 0);
    
            // 将最大分数的数据移动到最顶部
            const [maxItem] = list.splice(maxIndex, 1);
            list.unshift(maxItem);
    
            return list;
        }
    },
    created() {
        // 加载完成后 更新弹窗显示样式
        this.loadFlag = true

        if(this.getCookie('_OXVA_7th_')){
            this.isLogin = true
            this.user.token = this.getCookie('_OXVA_7th_')

            this.getInfo()
        }
        const preloadImages = () => {
            for(let i=1;i<57;i++){
                const img = new Image();
                img.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/oxva_7th_liquid_${i}.avif`;
                FRAME_URLS.push(img.src)
            }
            
        };
        preloadImages()

        this.getCountry()
        this.getData()

        // 缓存和句柄无需触发界面更新，因此不放入 data()。
        this.animationFrameId = 0;
        this.resultTimer = 0;
        // 每开始一次游戏递增；旧的异步倒计时/结算回调检查 token，避免串局。
        this.sessionToken = 0;
        this.disposed = false;
    },
    mounted() {
        window.addEventListener('keydown', this.onKeydown);

        this.updateWeeklyIndex();
        
        // 页面动画
        setTimeout(() => {
            $('.box1 p').css({opacity:1,transform:'translateY(0)'})
        }, 300);
    
        var video_flag = true
        if(wFlag){
            ScrollTrigger.create({
                trigger:'.box2',
                start:'top center-=10%',
                end:'+=0%',
                //toggleActions:'play none none reverse',
                onLeave: () => {
                    if(video_flag){
                        //$('.box2_item p,.box2_item a').css({opacity:0})
                        $('.box2_item video')[0].play()
                        video_flag = false
                    }
                },
                animation:gsap.timeline()
                    .from('.box2_item',{clipPath:'inset(0 100% 0 0)',duration:1})
                    .from('.box2_img',{x:'-320%',duration:1},'<')
                    .from('.box2_text,.box2_item p,.box2_item a',{opacity:0})
                    //.call(playVideo)
            })
        }else{
            ScrollTrigger.create({
                trigger:'.box2',
                start:'top center-=10%',
                end:'+=0%',
                //toggleActions:'play none none reverse',
                onLeave: () => {
                    if(video_flag){
                        //$('.box2_item p,.box2_item a').css({opacity:0})
                        $('.box2_item video')[0].play()
                        video_flag = false
                    }
                },
                animation:gsap.timeline()
                    .from('.box2_img',{x:'-146%',y:'-75%',scale:2.2})
                    .from('.box2_item',{opacity:0})
                    .from('.box2_text,.box2_item p,.box2_item a',{opacity:0})
                    //.call(playVideo)
            })
        }
    
        // $('.box2_item video').on('ended', function () {
        //     $('.box2_item p,.box2_item a').css({opacity:1})
        // })
    
        ScrollTrigger.create({
            trigger:'.box3',
            start:'top bottom-=30%',
            end:'+=120%',
            scrub:1,
            animation:gsap.timeline()
                .to('.box2_img img',{x:wFlag?'-164%':'-145%',y:wFlag?'176%':'375%',scale:wFlag?1:1.3})
                .from('.box3_bg',{opacity:0})
                .to('.box2_img img',{opacity:0},'<')
                .to('.box3_mask',{scale:wFlag?9:20})
                .from('.box3_prize',{opacity:0},'-=30%')
                .to('.box3_mask',{opacity:0},'<')
        })
    
        ScrollTrigger.create({
            trigger:'.box3',
            start:'top top+=5%',
            end:'+=100%',
            pin:true
        })
    
        if(!wFlag){
            new Swiper('.box3Swiper', {
                autoplay: true,
                navigation: {
                    nextEl: '.box3Swiper-button-next',
                    prevEl: '.box3Swiper-button-prev',
                },
            })
        }

    },
    beforeDestroy() {
        this.disposed = true;
        this.sessionToken++;
        this.clearScheduledWork();
        window.removeEventListener('keydown', this.onKeydown);
    },
    methods: {
        // 功能类-------------------------------------------------
        async getPoints(){
            if(this.user.is_share==1){
                return;
                //showMessage("You've already shared today. Come back tomorrow!",'success')
            }
            this.user.is_share=1
            let params=new URLSearchParams();
            params.append('action','Share');
            let res = await axios.post('https://service.oxvatech.cn/ox7th/getPoints',params,{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status==200){
                this.getInfo() //更新积分记录
                showMessage("You've earned 10 points!",'success')
            }
        },
        async sendEmail(){
            if(this.user.email == ''){
                showMessage('Please enter your email','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            if(this.sendFlag){
                showMessage('Sent, please try again in one minute.','success')
                setTimeout(() => {
                    this.sendFlag = false
                    this.sendText = 'Send code'
                }, 1000*60);
                return;
            }
            this.sendText = 'Has sent'
            this.sendFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/ox7th/sendEmail',params);
            if(res.data.status == 200){
                this.isSend = true
                showMessage('Email has been sent, please check.','success')
            }else{
                showMessage('Server error, please contact customer service','error')
            }
        },
        async loginActivity(){
            if(!this.isSend){
                showMessage('Please send the email verification code first','error')
                return;
            }
            if(!this.user.name || !this.user.email || this.user.country == 'Country' || !this.user.code){
                showMessage('Please fill in the information completely','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            //避免重复提交
            if(this.submitFlag) return;
            this.submitFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/ox7th/loginActivity',params);
            if(res.data.status == 200){
                this.setCookie('_OXVA_7th_',res.data.data,90)
                this.user.token = res.data.data
                showMessage('Good luck! ','success')
                this.popup = this.loginPopup = false
                this.getInfo()
            }else{
                let errorMessages = {
                    201: 'Email verification code error',
                    202: 'Username already exists',
                    500:' Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
            this.submitFlag = false
        },
        async getInfo(){
            let res = await axios.post('https://service.oxvatech.cn/ox7th/getInfo', {}, {
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                if(res.data.data.arr1.length>0){
                    this.isLogin = true
                    this.user = res.data.data.arr1[0]
                   
                    this.getUserRank()
                    // if(this.user.name == ''){}

                    //总积分记录
                    this.pointsHistory = res.data.data.arr2

                    //游戏分数记录
                    this.gameHistory = res.data.data.arr3
                    
                }else{
                    this.isLogin = false
                }
            }else{
                showMessage('server error','error')
            }
        },
        async getData(){
            let res = await axios.get('https://service.oxvatech.cn/ox7th/getData')
            if(res.status == 200){
                this.rankArr = res.data.data
                this.getUserRank()
            }
        },
        getUserRank(){
            for (const [index, item] of this.rankArr.entries()) {
                if (item.name === this.user.name) {
                    this.userRank = {
                        ...item,
                        rank: index + 1
                    };
                    break;
                }
            }
        },
        async getCountry(){
            let res = await axios.get('https://service.oxvatech.cn/public/getAllCountry')
            if(res.status == 200){
                this.countryArr = res.data.data
            }
        },
        async scoreLog(score,round){
            let params=new URLSearchParams();
            params.append('info',JSON.stringify({score:score,round:round}));
            let res = await axios.post('https://service.oxvatech.cn/ox7th/step',params,{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status==500){
                showMessage("Server error, please contact customer service",'error')
            }
        },
        async addGameData(){
            await axios.post('https://service.oxvatech.cn/ox7th/start',{},{
                headers: { Authorization: `${this.user.token}`}
            });
        },
        // 控件类-------------------------------------------------
        showPopup(type){
            if(!this.checkLogin()) return;
            this.popup = this[type] = true;
        },
        checkLogin(){
            if(!this.isLogin){
                this.popup = this.loginPopup = true;
                return false;
            }
            return true;
            // showMessage('Event ended. Thanks for joining!','success');
            // return false
        },
        endTips(){
            showMessage('Event ended. Thanks for joining!.','success')
        },
        emailUpdate(){
            if(this.isSend){
                this.isSend = false
                this.sendFlag = false
                this.sendText = 'Send code'
            }
        },
        closeGame(){
            this.game_ui=false;
            this.gameShow=true
            this.initGame()
        },
        reStart(){
            this.gameShow=true
            this.startGame()
        },
        start_game(){
            if(!this.isLogin){
                this.popup = this.loginPopup = true;
                return;
            }
            this.game_ui = true
            setTimeout(() => {
                gsap.timeline({delay:1}).to('.game_bg',{filter:'brightness(0.3)'}).to('.gameScreen,.rs_close',{opacity:1,y:0})
            }, 100);
        },
        // 工具类-------------------------------------------------
        async saveCanvas() {
            if (this.submitFlag) return;
            showMessage('Downloading, please wait. . .','success')
            this.submitFlag = this.download = true;

            
            setTimeout(async () => {
                const canvas = await html2canvas(this.$refs.container, {
                    backgroundColor: null,
                    useCORS: true,
                    allowTaint: false,
                    scale: 3
                })
    
                const link = document.createElement("a");
                link.download ="OXVA_7th_together_for_better.png";
                link.href = canvas.toDataURL("image/png");
                link.click();
                this.submitFlag = this.download = false;
            }, 100);
        },
        updateWeeklyIndex() {
            // 获取北京时间
            const parts = new Intl.DateTimeFormat('en-US', {
                timeZone: 'Asia/Shanghai',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            }).formatToParts(new Date());
    
            const get = type => Number(parts.find(p => p.type === type).value);
    
            const today = get('year') * 10000 + get('month') * 100 + get('day');
    
            // 各周开始日期
            const weekStarts = [
                20261027,
                20261102,
                20261109,
                20261116,
                20261123
            ];
    
            // 默认显示第一周
            this.weeklyIndex = 0;
    
            for (let i = 0; i < weekStarts.length; i++) {
                if (today >= weekStarts[i]) {
                    this.weeklyIndex = i;
                } else {
                    break;
                }
            }
        },
        toOrdinal(num){
            const n = Math.abs(num);
            const lastTwo = n % 100;
        
            if (lastTwo >= 11 && lastTwo <= 13) {
                return num + 'TH';
            }
        
            switch (n % 10) {
                case 1: return num + 'ST';
                case 2: return num + 'ND';
                case 3: return num + 'RD';
                default: return num + 'TH';
            }
        },
        formatISOToDateTime(isoString) {
            var date = new Date(isoString);
          
            // 转为北京时间（+8小时）
            date.setHours(date.getHours());
          
            var pad = (n) => n.toString().padStart(2, '0');
            var year = date.getFullYear();
            var month = pad(date.getMonth() + 1);
            var day = pad(date.getDate());
            var hours = pad(date.getHours());
            var minutes = pad(date.getMinutes());
            var seconds = pad(date.getSeconds());
          
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        copyCode(text){
            // 复制指定文案到剪贴板
            if(text=='invite'){
                text = this.user.invite_code
            }
            navigator.clipboard.writeText(text).then(() => {
                showMessage('Copied successfully','success')
            }).catch(err => {
                showMessage('Copied failed','error')
            });
        },
        QuickFind(){
            var countryList = this.$refs.countryList; // 获取 .country_option 元素
            // 找到第一个以输入字母开头的国家元素
            var targetCountry = Array.from(countryList.children).find((country) =>
                country.textContent.trim().toLowerCase().startsWith(this.findText.toLowerCase())
            );

            if (targetCountry) {
                // 滚动到目标国家
                targetCountry.scrollIntoView({ block: 'start' });
            }
        },
        // cookie
        setCookie(name,value,day){
            var d = new Date();
            d.setTime(d.getTime() + (day * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        },
        getCookie(name){
            var name = name + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArray = decodedCookie.split(';');
            for(let i = 0; i < cookieArray.length; i++) {
                let cookie = cookieArray[i];
                while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1);
                }
                if (cookie.indexOf(name) == 0) {
                return cookie.substring(name.length, cookie.length);
                }
            }
            return "";
        },
        // 游戏相关-------------------------------------------------------
        formatNumber(value) {
            // 显示工具--按浏览器默认区域格式化千分位。
            return Number(value).toLocaleString();
        },
        onKeydown(event) {
            if (event.code === 'Space' && this.running) {
                event.preventDefault();
                this.stopRound();
            }
        },
        // 【任务清理】停止帧动画并取消回合结束的定时器（不取消 wait 的倒计时 timeout）。
        clearScheduledWork() {
            this.running = false;
            cancelAnimationFrame(this.animationFrameId);
            clearTimeout(this.resultTimer);
            this.animationFrameId = 0;
            this.resultTimer = 0;
        },
        async startGame() {
            this.addGameData()
            // 令牌保护异步流程；组件销毁或后续重开后，旧回调不能覆盖新状态。
            const token = ++this.sessionToken;
            if (this.disposed || token !== this.sessionToken) return;
            this.clearScheduledWork();
            this.round = 0;
            this.score = 0;
            this.perfect = 0;
            this.saves = 0;
            this.frameIndex = 0;
            this.currentScreen = 'game';
            this.prepareRound(token);
        },
        renderLiquidFrame(level) {
            // 液位到图片映射--分数仍由液位百分比计算，帧编号只用于图片展示。
            const progress = Math.max(0, Math.min(1, (82 - level) / (82 - 13)));
            this.frameIndex = Math.round(progress * (FRAME_COUNT - 1));
        },
        makeCurve(round) {
            //速度设定--三关基准时长约 4800/3200/2100 ms，另加 ±6% 随机扰动。第一关线性；第二关有随机拐点的先慢后快；第三关四段不均匀速度
            const base = [4800, 3200, 2100][round];
            const jitter = (Math.random() * 0.12 - 0.06) * base;
            this.duration = base + jitter;
            this.curve = {
                breakpoint: 0.42 + Math.random() * 0.14,
                weights: [
                    0.7 + Math.random() * 0.1,
                    1.85 + Math.random() * 0.25,
                    0.54 + Math.random() * 0.12,
                    2.45 + Math.random() * 0.3
                ]
            };
        },
        wait(ms) {
            // 异步辅助--仅用于 3/2/1/GO 显示，不用于控制液位下降速度。
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        initGame() {
            this.sessionToken++;
            this.clearScheduledWork();
        
            this.round = 0;
            this.score = 0;
            this.perfect = 0;
            this.saves = 0;
        
            this.level = 82;
            this.frameIndex = 0;
        
            this.running = false;
            this.countdownVisible = false;
            this.flashVisible = false;
            this.instruction = 'Get ready…';
        
            this.makeCurve(this.round);
        
            // 进入游戏页面，但不启动动画
            this.currentScreen = 'start';
        },
        async prepareRound(token) {
            // 单关初始化
            if (this.disposed || token !== this.sessionToken) return;
            this.level = 82;
            this.renderLiquidFrame(this.level);
            this.instruction = 'Get ready…';
            this.running = false;
            this.flashVisible = false;
            this.flashData = { points: 0, label: '', icon: '', detail: '', saved: false };
            this.makeCurve(this.round);
            this.countdownVisible = true;

            // 3/2/1 各停留 430ms，GO 停留 250ms。
            for (const number of ['3', '2', '1']) {
                if (this.disposed || token !== this.sessionToken) return;
                this.countdownText = number;
                await this.wait(430);
            }
            if (this.disposed || token !== this.sessionToken) return;
            this.countdownText = 'GO';
            await this.wait(250);
            if (this.disposed || token !== this.sessionToken) return;

            this.countdownVisible = false;
            this.running = true;
            // 单调时钟基准；tick 计算实际经过时间而不是靠固定每帧减少液位。
            this.startTime = performance.now();
            this.instruction = PLAY_HINTS[this.round];
            this.animationFrameId = requestAnimationFrame(this.tick);
        },
        easedProgress(raw) {
            // 进度曲线--raw 是实际时间占本关 duration 的比例；返回液位下降比例 p。

            // 第 1 关：线性下降。
            if (this.round === 0) return raw;
            // 第 2 关：随机拐点 b 之前速度权重 0.56，之后 1.9。
            if (this.round === 1) {
                const b = this.curve.breakpoint;
                const slow = 0.56;
                const fast = 1.9;
                const total = b * slow + (1 - b) * fast;
                const distance = raw <= b ? raw * slow : b * slow + (raw - b) * fast;
                return Math.min(1, distance / total);
            }
            // 第 3 关：将整个进度划分为 4 段，各段使用不同的速度权重。
            const weights = this.curve.weights;
            const segment = 0.25;
            const total = weights.reduce((sum, weight) => sum + weight * segment, 0);
            let remaining = raw;
            let distance = 0;
            for (let i = 0; i < weights.length; i++) {
                const used = Math.min(segment, Math.max(0, remaining));
                distance += used * weights[i];
                remaining -= used;
            }
            return Math.min(1, distance / total);
        },
        tick(now) {
            // 动画主循环--rAF 每次得到当前时刻 now
            if (!this.running || this.disposed) return;
            const raw = Math.min(1, (now - this.startTime) / this.duration);
            const p = this.easedProgress(raw);
            this.level = Math.max(0, 82 - p * 75);
            this.renderLiquidFrame(this.level);
            if (this.level <= 13) {
                this.abtIntervene();
                return;
            }
            this.animationFrameId = requestAnimationFrame(this.tick);
        },
        stopRound() {
            // 玩家手动停止--以模拟液位 level 与目标 13% 的距离计算分数。可能有微小误差
            if (!this.running) return;
            this.running = false;
            cancelAnimationFrame(this.animationFrameId);
            this.animationFrameId = 0;

            // 距离 d = level - 13：越接近 0，分数越高；3 档如下。
            // 0<=d<=2.5: PERFECT（约 925~1000 分）
            // 2.5<d<=6: SAFE（约 638~900 分）
            // d>6: TOO EARLY（保底 200 分）。
            const distance = this.level - 13;
            const perfectWindow = 2.5;
            let points, label, icon, detail;
            if (distance <= perfectWindow) {
                points = Math.max(900, Math.round(1000 - distance * 30));
                label = 'PERFECT STOP';
                icon = '✦';
                detail = 'Right in the zone.';
                this.perfect++;
            } else if (distance <= 6) {
                points = Math.round(900 - (distance - perfectWindow) * 75);
                label = 'SAFE STOP';
                icon = '✓';
                detail = 'Close. Get even closer next round.';
            } else {
                points = Math.max(200, Math.round(640 - (distance - 6) * 11));
                label = 'TOO EARLY';
                icon = '◷';
                detail = 'Let it drop further next round.';
            }
            this.finishRound(points, label, icon, detail, false);
        },
        abtIntervene() {
            // ABT 自动保护--玩家未在液位降至 13% 前 STOP -> 本关 0 分，saves+1。
            if (!this.running) return;
            this.running = false;
            cancelAnimationFrame(this.animationFrameId);
            this.animationFrameId = 0;
            this.level = 13;
            this.renderLiquidFrame(this.level);
            this.saves++;
            this.finishRound(0, 'YOU MISSED IT.', this.selectedFace, '', true);
        },
        finishRound(points, label, icon, detail, saved) {
            // 统一回合结束--累计分数、记录是否触发 ABT，并显示 2500ms 的结果弹层。
            this.score += points;
            this.flashData = { points, label, icon, detail, saved };
            this.flashVisible = true;
            const token = this.sessionToken;
            this.scoreLog(points,this.round+1)
            this.resultTimer = setTimeout(() => {
                if (this.disposed || token !== this.sessionToken) return;
                this.round++;
                if (this.round < 3) this.prepareRound(token);
                else this.showResult();
            }, 2500);
        },
        showResult() {
            // 最终结算--比较并保存本机最高分，三轮最多 3000 分
            this.showBest = true;
            const stopped = 3 - this.saves;
            this.gameShow = false
            this.currentScreen = 'result';
            this.getData()
            this.getInfo()
        }
    }
};
// 【启动】
new Vue(gameOptions).$mount('#oxva_7th');